<style lang="scss">
  @use "../../assets/css/design-system/utils";
  @use "../../assets/css/design-system/mixins";
  @use "../../assets/css/design-system/colors";

  div {
    @include colors.utility_classes();
    @include mixins.body4-tooltip();

    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-radius: 6px;

    .icon {
      align-self: baseline;
    }
    > span.link {
      @extend .color-black_90;
    }

    &.information {
      &.high {
        @extend .background-color-systemInformation_10;
        @extend .color-systemInformation_100;
      }
      &.low {
        @extend .color-systemInformation_100;
      }
    }

    &.informationSubtle {
      &.high {
        @extend .background-color-interfaceSwGrey_10;
        @extend .color-black_90;
      }
      &.low {
        @extend .color-black_90;
      }
    }

    &.success {
      &.high {
        @extend .background-color-systemPositive_10;
        @extend .color-systemPositive_100;
      }
      &.low {
        @extend .color-systemPositive_100;
      }
    }

    &.successPurple {
      &.high {
        @extend .background-color-aiSurfacePurple;
        @extend .color-aiTextPurple;
      }
      &.low {
        @extend .color-aiTextPurple;
      }
    }

    &.warning {
      &.high {
        @extend .background-color-systemWarning_10;
        @extend .color-systemWarning_100;
      }
      &.low {
        @extend .color-systemWarning_100;
      }
    }

    &.error {
      &.high {
        @extend .background-color-systemError_10;
        @extend .color-systemError_100;
      }
      &.low {
        @extend .color-systemError_100;
      }
    }

    &.small {
      padding: utils.in_rem(4px) utils.in_rem(3px);
      gap: utils.in_rem(4px);
    }
    &.large {
      padding: utils.in_rem(8px) utils.in_rem(6px);
      gap: utils.in_rem(8px);

      // Large Inline Notification uses body2 font size with line height 21px
      // Padding used to keep icon aligned with the first line for multiline text
      .icon {
        padding: utils.in_rem(2.5px) 0;
      }
    }
  }
</style>

<script>
  import Icon from "./Icon.svelte";

  /** @type {"small" | "large"} */
  export let size = "large";

  /**
   * @type {"information"
   *   | "informationSubtle"
   *   | "warning"
   *   | "danger"
   *   | "success"}
   */
  export let message = "information";

  let cls = "";
  export { cls as class };

  /** @type {"low" | "high"} */
  export let contrast = "high";

  const iconMap = {
    success: "fas fa-check-circle",
    successPurple: "far fa-check-circle",
    information: "fas fa-info-circle",
    informationSubtle: "fas fa-info-circle",
    warning: "fas fa-exclamation-circle",
    error: "fas fa-exclamation-circle",
  };

  export let style = "";
</script>

<div class="{cls} {size} {message} {contrast}" {style}>
  <div class="icon">
    <Icon class={iconMap[message]} />
  </div>
  <slot />
  <span class="link">
    <slot name="link" />
  </span>
</div>
